import { useEffect, useState } from 'react'
import { scrollTo } from '@leshen/ui'
import { useUser } from '../context/UserProvider'

function UserPackages({
  /** Disable showing package cards if user location is from a geo lookup */
  disableGeo = false,
  /** The target id to scroll to */
  scrollTarget = '',
  /** Async package lookup method. exec params are userLocation */
  exec = () => {},
  /** Component to render, props = {loading, location, data} */
  component = () => {},
}) {
  const [loading, setLoading] = useState(false)
  const { userData, setUserData, userLocation } = useUser()
  const isClient = typeof window !== 'undefined'

  /**
   * Load packages based on userLocation.
   * disableGeo determines if we show package cards
   * if the user's location was a geo lookup.
   */
  useEffect(() => {
    const validZip = userLocation?.zipCode && userLocation.zipCode.length === 5
    if (!isClient || !validZip || (disableGeo && userLocation.geoLookup)) {
      return () => {}
    }
    setLoading(true)
    exec(userLocation)
      .then((packageData) => {
        setUserData(packageData || null)
      })
      .finally(() => {
        setLoading(false)
        if (scrollTarget) scrollTo(scrollTarget)
      })
    return () => {}
  }, [exec, disableGeo, scrollTarget, isClient, userLocation, setUserData])

  return component({ loading, location: userLocation, data: userData })
}

export default UserPackages
